import { render, staticRenderFns } from "./DashboardMarksIndex.vue?vue&type=template&id=3e181eef&"
import script from "./DashboardMarksIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardMarksIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports